<nz-modal [(nzVisible)]="isVisibleRefundModal" nzClassName="siteModal site-edit-modal invoice-modal"
    [nzTitle]="titleTemplate" (nzOnCancel)="handleCancel(null)" [nzFooter]="footerTpl" nzCentered [nzMaskClosable]="false">

    <ng-template #titleTemplate let-control>
        Refund <span class="Investment-modal-status bg-AFCCC1">
            <span>
                Completed</span>
        </span>
        <span nz-icon nzType="sync" nzTheme="outline" [nzSpin]="isResyncingData" (click)="resynRefundData()" class="ml-1 x-lg" nz-tooltip [nzTooltipTitle]="isResyncingData ? 'Syncing...' : 'Resync Refund'"></span>
    </ng-template>
    <ng-container *nzModalContent class="h-100">
        
        <div class="page-padding bg-white-color invoice-title-padding">
            <div nz-row class="d-flex align-i-c ">
                <div nz-col nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <h1 class="page-title-text tab-title">Refund Details (QBO Transaction)</h1>
                </div>
            </div>
        </div>

        <div class="page-padding bg-white-color">
            <div class="detail-box customer-detail-box" nz-row>
                <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="quickbooks-bg-color">
                    <div class="box-padding">
                        <nz-skeleton *ngIf="this.isLoadingRefundDetails" [nzParagraph]="{ rows: 8,width: 8}"
                            [nzActive]="true"></nz-skeleton>
                        <div nz-row nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" *ngIf="!this.isLoadingRefundDetails">
                            <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">User</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        QBO
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Submitted</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span
                                            *ngIf="(refundDetails.createdOn != null && refundDetails.createdOn != '') else elsepart ">
                                            {{refundDetails.createdOn.toString().slice(0,-1) 
                                            | date: 'MM/dd/yyyy'}} |
                                            {{refundDetails.createdOn.toString().slice(0,-1) 
                                            | date:'shortTime' }}</span>
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Product / Service</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span
                                            *ngIf="(refundDetails?.productServices?.name != null && refundDetails?.productServices?.name != '') else elsepart ">
                                            {{refundDetails?.productServices?.name}}</span>
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Type</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        
                                            {{refundDetails?.type == 2 ? 'Credit Memo' : 'Refund'}}
                                    </p>
                                </div>
                                <div class="d-flex mb-1">
                                    <label class="investment-approve-label-text">Memo</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span class="multiline-text"
                                            *ngIf="(refundDetails?.refundsDetails?.memo != null && refundDetails?.refundsDetails?.memo != '') else elsepart ">{{refundDetails?.refundsDetails?.memo}}</span>
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Reference Number</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span>
                                            <a  target="_blank"
                                            [href]="qboURL + '/app/'+ (refundDetails.type == 1 ? 'refundreceipt' : 'creditmemo')+'?txnId='+refundDetails?.qboEntityId">{{refundDetails?.qboEntityNo ? refundDetails?.qboEntityNo : 'No Ref No. Available'}}</a></span>
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">{{refundDetails?.type == 1 ? 'Refund Date' : 'Credit Memo Date'}}</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span
                                            *ngIf="(refundDetails?.refundReceiptdate != null && refundDetails?.refundReceiptdate != '') else elsepart ">
                                           {{refundDetails?.refundReceiptdate.slice(0,-1) | date : 'MM/dd/yyyy'}}</span>
                                    </p>
                                </div>                                
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Customer</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span
                                            *ngIf="(refundDetails?.quickBookCustomerDetails?.companyName != null && refundDetails?.quickBookCustomerDetails?.companyName != '') else elsepart ">
                                            {{refundDetails?.quickBookCustomerDetails?.companyName + ' | ' + refundDetails?.quickBookCustomerDetails?.name}}</span>
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Class</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span
                                            *ngIf="(refundDetails?.class?.name != null && refundDetails?.class?.name != '') else elsepart ">
                                            {{refundDetails?.class?.name}}</span>
                                    </p>
                                </div>
                                <div class="d-flex mb-1">
                                    <label class="investment-approve-label-text">Description</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span
                                            *ngIf="(refundDetails?.refundsDetails?.description != null && refundDetails?.refundsDetails?.description != '') else elsepart ">
                                            {{refundDetails?.refundsDetails?.description}}</span>
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Amount</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <span
                                            *ngIf="(refundDetails?.refundsDetails?.amount != null && refundDetails?.refundsDetails?.amount != '') else elsepart ">
                                            {{refundDetails?.refundsDetails?.amount | currency}}</span>
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Processing fee</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <!--*ngIf="(refundDetails?.balanceTransferDetails?.processingFee != null && refundDetails?.balanceTransferDetails?.processingFee != '') else elsepart "-->
                                        <span>
                                            {{refundDetails?.refundsDetails?.processingFee | currency }}</span>
                                    </p>
                                </div>
                                <div class="d-flex align-i-c mb-1">
                                    <label class="investment-approve-label-text">Net</label>
                                    <p class="investment-company-name pb-0 width-100">
                                        <!--*ngIf="(refundDetails?.balanceTransferDetails?.processingFee != null && refundDetails?.balanceTransferDetails?.processingFee != '') else elsepart "-->
                                        <span>
                                            {{refundDetails?.refundsDetails?.amount > 0 ? '-' : ''}}{{refundDetails?.refundsDetails?.amount - refundDetails?.refundsDetails?.processingFee | currency }}</span>
                                    </p>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                    <form nz-form [formGroup]="_fS.refundForm" class="estimate-box">
                        <div nz-row [nzGutter]="{ xs: 8, sm: 15, md: 15, lg: 20 }">
                            <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12" nzXl="12">
                                <div nz-row [nzGutter]="{ xs: 8, sm: 15, md: 15, lg: 20 }">
                                    <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="10">
                                        <nz-form-item>
                                            <nz-form-control [nzErrorTip]="programError">
                                                <label class="label-text required border-bottom">Select Program
                                                    Period</label>
                                                <nz-select nzShowSearch nzPlaceHolder="Select Program Period"
                                                    [nzSize]="'default'" formControlName="programPeriod" [nzSelectOnTab]="true">
                                                    <ng-container *ngFor="let option of listOfProgramPeriods">
                                                        <nz-option *ngIf="!isLoadingPrograms" [nzLabel]="option.label"
                                                            [nzValue]="option.id">
                                                        </nz-option>
                                                    </ng-container>
                                                    <nz-option *ngIf="isLoadingPrograms" nzCustomContent>
                                                        <span nz-icon nzType="loading" class="loading-icon"></span>
                                                        Loading Data...
                                                    </nz-option>
                                                </nz-select>
                                                <ng-template #programError let-control>
                                                    <ng-container *ngIf="control.hasError('required')">Please select
                                                        program
                                                        period
                                                    </ng-container>
                                                </ng-template>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                   
                                    <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="6">
                                        <nz-form-item class="h-100" style="margin-bottom: 0;">
                                            <nz-form-control class="switch-box justify-content-center">
                                                <nz-switch formControlName="isNonAlc"></nz-switch>
                                                <label class="switch-label black mr-1">Non-alc</label>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-template #elsepart let-event>
        <span>-</span>
    </ng-template>

    <ng-template #footerTpl>
        <div class="d-flex justify-content-end footer-box">
            <div class="ant-drawer-footer invoice-footer justify-content-end">
                <div class="d-flex">
                    <button nz-button nzType="default" (click)="handleCancel(null)"
                        class="dlt-btn width-100">Close</button>
                    <button nz-button nzType="primary" class="medium-btn small-btn width-100"
                        [nzLoading]="isLoadingRefund" (click)="updateRefund()">Update</button>
                </div>
            </div>
        </div>
    </ng-template>
</nz-modal>